import {jsonListIndex, JSONModel, jsonProperty} from "../json.model";

export class K2SiteModel extends JSONModel {
  static fromList(list: any) {
    if (!list || !Array.isArray(list)) return [];
    return (list as any[]).map(item => new K2SiteModel(item));
  }

  @jsonProperty("string") name: string;
  @jsonProperty("string") k2Name: string;
  @jsonProperty("string") k2Id: string;
  @jsonProperty("string") project_id: string;
  @jsonListIndex() index: number;
  @jsonProperty("boolean") selected: boolean;
  @jsonProperty("string") address: string;
  @jsonProperty("string") city: string;
  @jsonProperty("string") region: string;
  @jsonProperty("string") zipCode: string;
}
